import ko from "knockout";
import uniqueId from "flow/utils/uniqueId";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";

export function selectIdAttr(prefix: string, attr: MaybeObservableAttributes): KnockoutObservable<string> {
    // Store default value as not run uniqueId more than once
    // Revisit to avoid running at all if not needed
    const proposedId = uniqueId(prefix);
    return ko.pureComputed(() => {
        const userAttrs = ko.unwrap(attr);
        return userAttrs?.id ? ko.unwrap(userAttrs.id) : proposedId;
    });
}

export function selectIdStatic(prefix: string, attr: MaybeObservableAttributes): string {
    const userAttr = ko.unwrap(attr);
    return userAttr?.id ? ko.unwrap(userAttr.id) : uniqueId(prefix);
}

export function selectId(prefix: string, id: MaybeObservable<string>): MaybeObservable<string> {
    return id || uniqueId(prefix);
}
